// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".truncate-text{position:relative;overflow:hidden;max-width:99%;white-space:nowrap;text-overflow:ellipsis}\n", ""]);
// Exports
module.exports = exports;
